import Technology from '../components/Technology';
export default function TechnologyPage() { return <Technology />; }
